import OrganisationTypeEnum from '@constants/enums/organisation/type';

import AdviserApi from '@packages/advisers/api';

import { Organisation, VisibilityGroup, BankAccount } from '@/models';

export class Adviser extends Organisation {
    static name = 'Adviser';
    static entity = 'advisers';
    static Api = AdviserApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(OrganisationTypeEnum, OrganisationTypeEnum.ADVISER).nullable(),
            parent_id: this.string(null).nullable(),
            custom_app_url: this.string(null).nullable(),
            auth_client_id: this.string(null).nullable(),
            auth_client_secret: this.string(null).nullable(),
            default_panel_id: this.string(null).nullable(),
            default_panel: this.attr(null).nullable(),
            primary_contact: this.attr(null).nullable(),
            public_adviser_id: this.string(null).nullable(),
            visibility_groups: this.modelList(VisibilityGroup, []).nullable(),
            new_registrations_advised: this.boolean(false).nullable(),
            new_registrations_contact_id: this.string(null).nullable(),
            bank_accounts: this.modelList(BankAccount, null).nullable(),
            disable_investor_welcome_page: this.boolean(false).nullable(),
            disable_cobranded_reports: this.boolean(false).nullable(),
            investor_portfolio_restricted: this.boolean(false).nullable(),
            default_platform_fee: this.number(null).nullable()
        };
    }

    static validation() {
        return {
            SettingsFirmInformation: {
                name: 'required:name',
                fca_number: 'required:fca_number',
                addresses: ['required:addresses']
            }
        };
    }

    get primary_contact_name() {
        return this.primary_contact ? this.primary_contact.name : null;
    }

    get some_investors_have_portfolio_restrictions() {
        return this.investor_portfolio_restricted;
    }
}

export default Adviser;
